import script from "./NewsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPage.vue?vue&type=script&setup=true&lang=js"

import "./NewsPage.vue?vue&type=style&index=0&id=260dd960&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-260dd960"]])

export default __exports__